import React, { useState, useRef, useEffect } from 'react';
import { GridComponent, Inject, ColumnsDirective, ColumnDirective, Search, Page, Toolbar, Sort } from '@syncfusion/ej2-react-grids';
import { Header } from '../../../components'
import useAppwrite from '../../../lib/useAppwrite';
import { config, deleteDocument, getAllDocuments, getCurrentUser } from '../../../lib/appwrite';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { useStateContext } from '../../../contexts/ContextProvider';
import { FaEye, FaRegEdit } from 'react-icons/fa';
import { FaCirclePlus, FaTrashCan } from "react-icons/fa6";
// import EditUser from './EditUser';
import EditableTable from '../../../components/EditableTable';
import { TbEye, TbEyeCog } from "react-icons/tb";
import EditBooking from './EditBooking';
import ConfirmDelete from '../../../components/ConfirmDelete';
import CalendarSelect from '../../../components/CalendarSelect'

const Calendar = () => {
  const { data: user } = useAppwrite(
    () => getCurrentUser()
  );

  const { currentColor } = useStateContext();
  const [createBooking, setCreateBooking] = useState(false)
  const [editBooking, setEditBooking] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)

  // Table variables
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [reset, setReset] = useState(false)
  const [bookings, setBookings] = useState([])

  useEffect(() => {
    if (editBooking === false) {
      refetch()
    }
  }, [editBooking]);

  useEffect(() => {
    if (!selectedRowData) {
      setReset(true)
    }
  }, [selectedRowData])

  const handleRowSelect = (data) => {
    setSelectedRowData(data);
  };

  const handleDelete = async () => {
    setConfirmDelete(false)
    await deleteDocument(selectedRowData.$id, config.bookingsCollectionId)
    refetch()
    setSelectedRowData(null)
  }

  // Data
  const { data: data, isLoading, refetch } = useAppwrite(
    () => getAllDocuments(config.bookingsCollectionId)
  );

  useEffect(() => {
    if (data) {
      setBookings(data);
    }
  }, [data]);
  // ======================================== Edit QualityRecord Vars ======================================== //


  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white dark:bg-secondary-dark-bg rounded-3xl">
      <div className={`${createBooking ? 'block' : 'hidden'} overflow-scroll`}>
        <EditBooking view={createBooking} setView={setCreateBooking} selectedRowData={selectedRowData} setSelectedRowData={setSelectedRowData} mode={'create'} />
      </div>
      <div className={`${editBooking ? 'block' : 'hidden'} overflow-scroll`}>
        <EditBooking view={editBooking} setView={setEditBooking} selectedRowData={selectedRowData} setSelectedRowData={setSelectedRowData} mode={'edit'} />
      </div>
      <Header category="" title="Bookings" isLoading={isLoading} />

      <div className='flex flex-1 justify-end items-center my-2'>
        <TooltipComponent content="Create Booking" position='TopCenter'>
          <button
            type='button'
            onClick={() => setCreateBooking(true)}
            style={{ color: 'rgb(153, 171, 180)', borderRadius: '50%' }}
            className='text-2xl p-3 hover:drop-shadow-xl hover:bg-light-gray'
          >
            <FaCirclePlus className='text-xl' style={{ color: currentColor }} />
          </button>
        </TooltipComponent>
        <div className={`${selectedRowData ? 'block' : 'hidden'}`}>
          <TooltipComponent content="Review Booking" position='TopCenter'>
            <button
              type='button'
              onClick={() => setEditBooking(true)}
              style={{ color: 'rgb(153, 171, 180)', borderRadius: '50%' }}
              className='text-2xl p-3 hover:drop-shadow-xl hover:bg-light-gray'
            >
              <FaRegEdit className='text-xl' style={{ color: currentColor }} />
            </button>
          </TooltipComponent>
        </div>
        <div className={`${selectedRowData ? 'block' : 'hidden'}`}>
          <TooltipComponent content="Delete Booking" position='TopCenter'>
            <button
              type='button'
              onClick={() => setConfirmDelete(true)}
              style={{ borderRadius: '50%' }}
              className='text-2xl p-3 hover:drop-shadow-xl hover:bg-light-gray'
            >
              <FaTrashCan className='text-xl text-red-500' />
            </button>
          </TooltipComponent>
        </div>
      </div>
      <EditableTable
        title=""
        data={bookings}
        setData={setBookings}
        rowActions={[]}
        keyMapping={{
          'First Name': 'firstName',
          'Last Initial': 'lastInitial',
          'Status': 'status'
        }}
        onRowClick={handleRowSelect} // Assuming handleRowSelect is a defined function
        reset={reset}
        setReset={setReset}
        selectable={true}
      />
      <ConfirmDelete
        title="Confirm Deletion?"
        text="Are you sure you want to delete the following? This action cannot be undone."
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
        visible={confirmDelete}
        setVisible={setConfirmDelete}
        handleConfirm={() => handleDelete()}
      />
    </div>

  );
};

export default Calendar;